import { createSlice } from '@reduxjs/toolkit';

// Prepare > Automix preferences — persisted via PERSISTED_SLICES. Device-scoped
// (a folder on this machine, how this DJ likes a set ordered), so they survive
// an account change.
const initialState = {
    // Where finished sets are saved; null = the engine's default folder.
    outDir: null,
    // 'flow' = the engine finds the best running order; 'playlist' = keep mine.
    order: 'flow',
    // Stem-aware analysis (vocals / bass / drums / melody located per record)
    // for records that have none cached. Only offered where Demucs is set up.
    stems: true,
};

const automixSettingsSlice = createSlice({
    name: 'automixSettings',
    initialState,
    reducers: {
        setOutDir(state, action) {
            state.outDir = action.payload || null;
        },
        setOrder(state, action) {
            state.order = action.payload === 'playlist' ? 'playlist' : 'flow';
        },
        setStems(state, action) {
            state.stems = !!action.payload;
        },
        hydrate(state, action) {
            Object.assign(state, action.payload);
        },
    },
});

export const { setOutDir, setOrder, setStems, hydrate } = automixSettingsSlice.actions;
export default automixSettingsSlice.reducer;
